export default __webpack_public_path__ + "static/media/Home-section-5-01.df916cdf.png";